import styles from '../DetailsProfile/DetailsProfile.module.scss';

interface InfoSectionProps {
  title: string;
  text: string;
}

export const InfoSection = ({ title, text }: InfoSectionProps) => (
  <section className={styles['profile-card__item-info']}>
    <h3>{title}</h3>
    <p style={{ whiteSpace: 'pre-wrap' }}>{text}</p>
  </section>
);
